import { useCallback, useEffect, useState } from 'react';

// Change this to wherever dashboard.php is served from.
export const DASHBOARD_API_URL = 'https://staging.reports.netlibsecurity.com/dashboard.php';

/**
 * Loads the whole dashboard in one request whenever the filters change.
 * Keeps showing the previous data while a new request is in flight, so the
 * page doesn't flash empty when someone changes the date range.
 */
export default function useActivationsDashboard({ from, to, product, customer, excludeTest }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    const params = new URLSearchParams({
      from,
      to,
      product: product ?? '',
      customer: customer ?? '',
      excludeTest: excludeTest ? '1' : '0',
    });

    setLoading(true);
    setError(null);

    fetch(`${DASHBOARD_API_URL}?${params}`, {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
    })
      .then(async (res) => {
        const body = await res.json().catch(() => null);
        if (!res.ok) throw new Error(body?.error || `Request failed (${res.status})`);
        return body;
      })
      .then((body) => {
        setData(body);
        setLoading(false);
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        setError(err.message || 'Could not load the dashboard');
        setLoading(false);
      });

    return () => controller.abort();
  }, [from, to, product, customer, excludeTest, reloadKey]);

  const reload = useCallback(() => setReloadKey((k) => k + 1), []);

  return { data, loading, error, reload };
}
